import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import Iconfont from '@utils/Iconfont';
import Utils from '@utils/utils';
import { BATCH_IMAGES_TYPE } from '@utils/CONST';
import styles from '../../../index.module.scss';

const SelectionMask = ({ show }) => {
    if (!show) return null;
    return <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.6)', zIndex: 10, cursor: 'not-allowed' }} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} />
};

export const GrassPlantModelCell = ({ record, showSelectionColumn, openReferenceDrawer }) => {
    return record?.modelList?.length === 0 ? (
        <div
            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
            style={{ width: 536 }}
            onClick={() => openReferenceDrawer([], 10, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
            <SelectionMask show={showSelectionColumn} />
            <div className={styles.SelectModelBtnContent}>
                <PlusOutlined />
                <p>选择1到10张网红图</p>
            </div>
        </div>
    ) : (
        <div className={styles.refListBox} style={{ maxWidth: 536 }}>
            <SelectionMask show={showSelectionColumn} />
            {record?.modelList?.slice(0, 5)?.map((item, index) => (
                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
            ))}
            {
                record?.modelList?.length > 5 && (
                    <p className={styles.number}>
                        <Iconfont type="icon-copyOutlined" />
                        <span>{record?.modelList?.length}</span>
                    </p>
                )
            }
            <div className={styles.maskBox}
                onClick={() => openReferenceDrawer([...record?.modelList], 10, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
            </div>
        </div>
    );
};

export const GrassPlantBkgCell = ({ record, showSelectionColumn, openReferenceDrawer, handleRefListDrop }) => {
    return record?.bkgList?.length === 0 ? (
        <div
            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
            style={{ width: 536 }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleRefListDrop(e, record, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)}
            onClick={() => openReferenceDrawer([], 10, record, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)}>
            <SelectionMask show={showSelectionColumn} />
            <div className={styles.SelectModelBtnContent}>
                <PlusOutlined />
                <p>选择1到10张背景氛围图</p>
            </div>
        </div>
    ) : (
        <div className={styles.refListBox} style={{ maxWidth: 536 }}>
            <SelectionMask show={showSelectionColumn} />
            {record?.bkgList?.slice(0, 5)?.map((item, index) => (
                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
            ))}
            {
                record?.bkgList?.length > 5 && (
                    <p className={styles.number}>
                        <Iconfont type="icon-copyOutlined" />
                        <span>{record?.bkgList?.length}</span>
                    </p>
                )
            }
            <div className={styles.maskBox}
                onClick={() => openReferenceDrawer([...record?.bkgList], 10, record, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)}>
                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
            </div>
        </div>
    );
};